import {BaseCommand} from './base.command';
import {OverlayElementSnapshot} from '../interfaces/command.interface';
import {OverlayElementApiService} from '../../../api/services/overlay-element.service';
import {OverlayElementManagerService} from '../../overlay-element-manager.service';
import {firstValueFrom} from 'rxjs';

export class DeleteOverlayElementCommand extends BaseCommand<OverlayElementSnapshot> {
  constructor(
    private overlayService: OverlayElementApiService,
    private overlayManager: OverlayElementManagerService,
    snapshot: OverlayElementSnapshot
  ) {
    super(
      'delete-overlay-element',
      'Overlay Deletion',
      {
        before: snapshot,
        after: {element: {} as any}
      },
      {object: 'Overlay', verb: 'Deletion'}
    );
  }

  async execute(): Promise<void> {
    const element = this.snapshot.before.element;
    if (!element?.id) return;

    await firstValueFrom(this.overlayService.delete(element.id));
    this.overlayManager.removeElement(element.id);
  }

  async undo(): Promise<void> {
    const element = this.snapshot.before.element;
    if (!element?.id) return;

    await firstValueFrom(this.overlayService.restore(element.id));
    this.overlayManager.addElement(element);
  }
}
